let ControllerName = 'Pages';
const PagesController = Object.freeze({
    PageByCode: `${ControllerName}/page-by-code`,
    WhatsAppLink: `${ControllerName}/whatsapp-link`,
});

export default PagesController;